import { render } from "./OrderIndex.vue?vue&type=template&id=3d3d6563&ts=true"
import script from "./OrderIndex.vue?vue&type=script&lang=ts"
export * from "./OrderIndex.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/chooza-gift-app/chooza-gift-app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__